module.exports = __webpack_public_path__ + "img/blt-search02.a2b150bc.svg";